<template>
  <v-toolbar
    class="align-self-center transparent px-2 px-sm-4"
    width="inherit"
    dark
    flat
  >
    <router-link
      :to="{ params: { lang: 'de' }, name: 'Home' }"
      class="align-self-center"
    >
      <v-img max-width="50" src="../assets/logo.png"></v-img>
    </router-link>
    <v-divider vertical class="mx-sm-4 mx-2" dark inset></v-divider>
    <v-toolbar-title class="align-self-center">
      <router-link
        class="text-decoration-none white--text"
        :to="{ params: { lang: 'de' }, name: 'Home' }"
      >
        <div
          class="font-weight-medium"
          :style="{ 'font-size': $vuetify.breakpoint.mobile ? '18px' : '' }"
        >
          Turngemeinde Schwalbach
          <br />1887 e.V.
        </div>
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <v-app-bar-nav-icon
      @click="$emit('toggel-drawer', !drawer)"
      class="hidden-md-and-up align-self-center"
    ></v-app-bar-nav-icon>

    <v-toolbar-items class="hidden-sm-and-down">
      <template v-for="(nav, i) in navigation">
        <v-btn
          :class="nav.name === $route.name ? 'active' : 'not_active'"
          active-class="active"
          v-if="!nav.dropdown"
          exact
          text
          :key="i"
          :to="{ params: { lang: 'de' }, name: nav.name }"
        >
          {{ $t(nav.translation) }}
        </v-btn>
        <v-menu
          v-else
          transition="slide-y-transition"
          :key="i"
          bottom
          offset-y
          tile
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              {{ $t(nav.translation) }}
            </v-btn>
          </template>
          <v-list v-if="nav.name === 'Abteilungen' && departments.length > 0">
            <v-list-item
              v-for="item in departments"
              :key="item._id"
              :to="{
                params: { lang: 'de' },
                name: 'Abteilungen',
                params: { id: item.title },
              }"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list v-if="nav.name === 'Workshops' && workshops.length > 0">
            <v-list-item
              v-for="item in workshops"
              :key="item._id"
              :to="{
                params: { lang: 'de' },
                name: 'Workshops',
                params: { id: item.title.toLowerCase() },
              }"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list
            v-if="
              (nav.name === 'Abteilungen' && !departments.length > 0) ||
              (nav.name === 'Workshops' && !workshops.length > 0)
            "
          >
            <v-list-item>
              <small class="grey--text text-center">{{
                $t("no_data_loaded")
              }}</small>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-divider :key="i + navigation.length" vertical inset></v-divider>
      </template>
      <v-menu left transition="slide-y-transition" class="" bottom offset-y nudge-bottom="20px" tile>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, i) in navigations"
            :key="i"
            :to="{
              params: { lang: 'de' },
              name: item.name,
            }"
            v-show="item.name === 'Dashboard' ? isLoggedIn : true"
          >
            <v-list-item-title>{{ $t(item.translation) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  props: ["drawer", "navigation", "navigations"],
  data: () => ({
    selectors: ["#offers", "#workshops", "#blogposts", "#sponsors"],
    dashboard: { translation: "nav.dashboard", name: "Dashboard" },
  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/getLoggedIn"];
    },
    departments() {
      return this.$store.getters["publicApi/getDepartments"];
    },
    workshops() {
      return this.$store.getters["publicApi/getWorkshops"];
    },
  },
};
</script>

<style lang="scss" scoped>
.v-toolbar__content {
  padding: 0px 0px !important;
}

.active::before {
  content: "";
  background-color: #4664FF !important;
  position: absolute;
  height: 8px;
  bottom: 0;
  opacity: 1;
  z-index: 1000;
  right: 0;
  margin-top: auto;
  border-radius: 9999px;
}
</style>